import { render } from "./ShipmentList_menu_edit_group.vue?vue&type=template&id=7507bd3b"
import script from "./ShipmentList_menu_edit_group.vue?vue&type=script&lang=js"
export * from "./ShipmentList_menu_edit_group.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__